import React from 'react';
import { Form, Input, Button, Card, Row, Col, Typography } from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  ArrowRightOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  ArrowLeftOutlined,
  SafetyOutlined,
} from '@ant-design/icons';
import { ValidationRules } from '../createCompanyPublic/validationRules';

const { Title, Paragraph, Text } = Typography;

interface AdminFormProps {
  form: any;
  onFinish: (values: any) => void;
  loading: boolean;
  onPrevious: () => void;
}

const AdminForm: React.FC<AdminFormProps> = ({ form, onFinish, loading, onPrevious }) => {

  return (
    <Card className="form-card modern-card enhanced" loading={loading} style={{ marginTop: '0' }}>
        <div className="step-header" style={{ 
          background: 'white', 
          color: '#2d3748',
          padding: '24px 0',
          marginBottom: '24px',
          textAlign: 'center'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            fontSize: '24px',
            color: 'white'
          }}>
            <UserOutlined />
          </div>
          <Title level={2} 
          // className="step-title" 
          style={{ color: '#2d3748 !important', marginBottom: '8px' }}>
            Yönetici Hesabınızı Oluşturun
          </Title>
          <Paragraph 
          // className="step-description" 
          style={{ color: '#4a5568 !important', fontSize: '16px', marginBottom: '0' }}>
            Şirketinizin dijital dönüşümünü yönetecek süper yönetici hesabını oluşturun.
          </Paragraph>
        </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        size="large"
        // requiredMark="optional"
        className="modern-form"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Form.Item
              name="firstName"
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748', 
                  marginBottom: '8px' 
                }}>
                  <UserOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Adınız
                  <span style={{ color: '#ff6b6b', fontWeight: 700, marginLeft: '4px' }}>*</span>
                </span>
              }
              rules={ValidationRules.name}
            >
              <Input 
                placeholder="Adınızı girin"
                maxLength={50}
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              name="lastName"
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748' 
                }}>
                  <UserOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Soyadınız
                  <span style={{ color: '#ff6b6b', fontWeight: 700, marginLeft: '4px' }}>*</span>
                </span>
              }
              rules={ValidationRules.name}
            >
              <Input 
                placeholder="Soyadınızı girin"
                maxLength={50}
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item 
              name="email" 
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748' 
                }}>
                  <MailOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Yönetici E-posta Adresi
                  <span style={{ color: '#ff6b6b', fontWeight: 700, marginLeft: '4px' }}>*</span>
                </span>
              }
              rules={ValidationRules.email}
            >
              <Input
                placeholder="yonetici@sirketiniz.com"
                type="email"
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              name="password"
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748' 
                }}>
                  <SafetyOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Şifre
                  <span style={{ color: '#ff6b6b', fontWeight: 700, marginLeft: '4px' }}>*</span>
                </span>
              }
              rules={ValidationRules.password}
            >
              <Input.Password
                placeholder="Güçlü bir şifre oluşturun"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              name="confirmPassword"
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748' 
                }}>
                  <SafetyOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Şifre Onayı
                  <span style={{ color: '#ff6b6b', fontWeight: 700, marginLeft: '4px' }}>*</span>
                </span>
              }
              dependencies={['password']}
              rules={[
                { required: true, message: "Şifre tekrarı zorunludur" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Şifreler eşleşmiyor!'));
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Şifrenizi tekrar girin"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item 
              name="phone" 
              label={
                <span style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  fontWeight: 600, 
                  fontSize: '15px', 
                  color: '#2d3748' 
                }}>
                  <PhoneOutlined style={{ color: '#667eea', fontSize: '16px' }} />
                  Telefon Numarası
                </span>
              }
              rules={[
                { 
                  pattern: /^[5][0-9]{9}$/,
                  message: 'Geçerli bir telefon numarası giriniz'
                }
              ]}
            >
              <Input
                placeholder="5XX XXX XX XX"
                maxLength={10}
                style={{
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  padding: '12px 16px',
                  fontSize: '16px',
                  background: 'white',
                  height: '48px'
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <div className="form-footer" style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Button
                type="default"
                size="large"
                onClick={onPrevious}
                block
                icon={<ArrowLeftOutlined />}
                style={{ 
                  height: '56px',
                  borderRadius: '16px',
                  border: '2px solid #e2e8f0',
                  color: '#374151',
                  backgroundColor: '#ffffff',
                  fontSize: '16px',
                  fontWeight: 600
                }}
              >
                Önceki Adım
              </Button>
            </Col>
            <Col xs={24} sm={12}>
              <Button
                type="primary"
                htmlType="submit"
                icon={!loading && <ArrowRightOutlined />}
                loading={loading}
                size="large"
                block
                className="modern-submit-btn enhanced"
                style={{
                  height: '56px',
                  fontSize: '16px',
                  fontWeight: 600,
                  borderRadius: '16px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  boxShadow: '0 8px 24px rgba(102, 126, 234, 0.4)',
                  color: 'white'
                }}
              >
                {loading ? 'Hesap Oluşturuluyor...' : 'Devam Et'}
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    </Card>
  );
};

export default React.memo(AdminForm);